module.exports = __webpack_public_path__ + "static/img/HK-Windows.7a5033d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HK-Windows.png
// module id = 5mxH
// module chunks = 3